import React from 'react';
import { ImageWithTextSectionStoryblok } from '../../types/storyblok';
import { Box } from '../../base/Box/Box';
import { Desktop } from './Desktop';
import { Mobile } from './Mobile';

const ImageWithTextSection = ({
  colourScheme = 'white',
  overlayOverBkg,
  ...props
}: ImageWithTextSectionStoryblok) => (
  <Box
    as="section"
    colourScheme={colourScheme || 'white'}
    blockSpacing
    bkg
    overlayOverBkg={overlayOverBkg}
  >
    <Box as="div" className="hidden md:block">
      <Desktop {...props} />
    </Box>
    <Box as="div" className="block md:hidden">
      <Mobile {...props} />
    </Box>
  </Box>
);

export default ImageWithTextSection;
